import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Header } from "@/components/admin/BookingsTab";
import { Badge } from "@/components/ui/badge";

export default function AuditLogsTab() {
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/audit-logs"); setLogs(data); }
      catch { toast.error("Load failed"); }
    })();
  }, []);
  return (
    <div>
      <Header title="Audit Logs" subtitle="Every admin action, timestamped and traceable." />
      <div className="glass-card rounded-2xl border border-white/10 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-white/[0.03] text-xs uppercase tracking-wider text-slate-400">
            <tr>{["Timestamp", "User", "Action", "Target", "IP", "Details"].map(h => <th key={h} className="text-left px-4 py-3 font-medium">{h}</th>)}</tr>
          </thead>
          <tbody>
            {logs.length === 0 && <tr><td colSpan="6" className="text-center py-12 text-slate-500">No audit entries.</td></tr>}
            {logs.map((l, i) => (
              <tr key={i} className="border-t border-white/5" data-testid={`audit-row-${i}`}>
                <td className="px-4 py-3 font-mono text-xs text-slate-400">{new Date(l.timestamp).toLocaleString()}</td>
                <td className="px-4 py-3 text-slate-300">{l.user_email}</td>
                <td className="px-4 py-3"><Badge className="bg-amber-400/20 text-amber-300 border-amber-400/40 border font-mono uppercase text-[10px] tracking-wider">{l.action}</Badge></td>
                <td className="px-4 py-3 font-mono text-xs text-slate-500 max-w-xs truncate">{l.target}</td>
                <td className="px-4 py-3 font-mono text-xs text-slate-500">{l.ip || "-"}</td>
                <td className="px-4 py-3 text-xs text-slate-500 max-w-xs truncate">{l.details}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
